/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FlightSearchRequest } from './FlightSearchRequest';
import {
    FlightSearchRequestFromJSON,
    FlightSearchRequestFromJSONTyped,
    FlightSearchRequestToJSON,
    FlightSearchRequestToJSONTyped,
} from './FlightSearchRequest';
import type { SearchPromptResponse } from './SearchPromptResponse';
import {
    SearchPromptResponseFromJSON,
    SearchPromptResponseFromJSONTyped,
    SearchPromptResponseToJSON,
    SearchPromptResponseToJSONTyped,
} from './SearchPromptResponse';
import type { Viewport } from './Viewport';
import {
    ViewportFromJSON,
    ViewportFromJSONTyped,
    ViewportToJSON,
    ViewportToJSONTyped,
} from './Viewport';
import type { UserEnvironment } from './UserEnvironment';
import {
    UserEnvironmentFromJSON,
    UserEnvironmentFromJSONTyped,
    UserEnvironmentToJSON,
    UserEnvironmentToJSONTyped,
} from './UserEnvironment';
import type { HotelSearchRequest } from './HotelSearchRequest';
import {
    HotelSearchRequestFromJSON,
    HotelSearchRequestFromJSONTyped,
    HotelSearchRequestToJSON,
    HotelSearchRequestToJSONTyped,
} from './HotelSearchRequest';

/**
 * A generic search request for flights, hotels or both
 * @export
 * @interface SearchRequestV2
 */
export interface SearchRequestV2 {
    /**
     * 
     * @type {UserEnvironment}
     * @memberof SearchRequestV2
     */
    userEnvironment: UserEnvironment;
    /**
     * 
     * @type {FlightSearchRequest}
     * @memberof SearchRequestV2
     */
    flights?: FlightSearchRequest;
    /**
     * 
     * @type {HotelSearchRequest}
     * @memberof SearchRequestV2
     */
    hotels?: HotelSearchRequest;
    /**
     * The prompt ID
     * @type {string}
     * @memberof SearchRequestV2
     */
    promptId: string;
    /**
     * 
     * @type {SearchPromptResponse}
     * @memberof SearchRequestV2
     */
    promptResponse?: SearchPromptResponse;
    /**
     * 
     * @type {Viewport}
     * @memberof SearchRequestV2
     */
    viewport?: Viewport;
    /**
     * 
     * @type {boolean}
     * @memberof SearchRequestV2
     */
    test?: boolean;
}



/**
 * Check if a given object implements the SearchRequestV2 interface.
 */
export function instanceOfSearchRequestV2(value: object): value is SearchRequestV2 {
    if (!('userEnvironment' in value) || value['userEnvironment'] === undefined) return false;
    if (!('promptId' in value) || value['promptId'] === undefined) return false;
    return true;
}

export function SearchRequestV2FromJSON(json: any): SearchRequestV2 {
    return SearchRequestV2FromJSONTyped(json, false);
}

export function SearchRequestV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchRequestV2 {
    if (json == null) {
        return json;
    }
    return {
        
        'userEnvironment': UserEnvironmentFromJSON(json['user_environment']),
        'flights': json['flights'] == null ? undefined : FlightSearchRequestFromJSON(json['flights']),
        'hotels': json['hotels'] == null ? undefined : HotelSearchRequestFromJSON(json['hotels']),
        'promptId': json['prompt_id'],
        'promptResponse': json['prompt_response'] == null ? undefined : SearchPromptResponseFromJSON(json['prompt_response']),
        'viewport': json['viewport'] == null ? undefined : ViewportFromJSON(json['viewport']),
        'test': json['test'] == null ? undefined : json['test'],
    };
}

export function SearchRequestV2ToJSON(json: any): SearchRequestV2 {
    return SearchRequestV2ToJSONTyped(json, false);
}

export function SearchRequestV2ToJSONTyped(value?: SearchRequestV2 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_environment': UserEnvironmentToJSON(value['userEnvironment']),
        'flights': FlightSearchRequestToJSON(value['flights']),
        'hotels': HotelSearchRequestToJSON(value['hotels']),
        'prompt_id': value['promptId'],
        'prompt_response': SearchPromptResponseToJSON(value['promptResponse']),
        'viewport': ViewportToJSON(value['viewport']),
        'test': value['test'],
    };
}

